import React from "react";
import { useQueryClient, useSuspenseQuery } from "@tanstack/react-query";
import { withFallback } from "vike-react-query";
import { usePageContext } from "vike-react/usePageContext";
import { useDispatch, useSelector } from "react-redux";
import { fetchClub, joinClub, leaveClub } from "#redux/slices/clubSlice";
import { openModal } from "#redux/slices/globalUISlice";
import HeadTags from "#helpers/HeadTags";
import Button from "#helpers/Button";
import { CLUB_THEMES } from "#utils/constants";
import Forum from "#components/forum/Forum";
import AllClubBooks from "./AllClubBooks";
import AboutUsMemberView from "./AboutUsMemberView";
import AboutUsModeratorView from "./AboutUsModeratorView";
import { getMaterialIcon } from "#utils/icons";
const LockOutlinedIcon = getMaterialIcon("LockOutlined");

const ClubShow = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const {
    routeParams: { uuid, view },
  } = usePageContext();
  const { currentUserId } = useSelector((state) => state.user);

  const { data: club, refetch: refetchClub } = useSuspenseQuery({
    queryKey: ["club", uuid],
    queryFn: () => dispatch(fetchClub(uuid)).unwrap(),
  });

  const handleJoin = () => {
    if (!currentUserId) return dispatch(openModal({ name: "loginPrompt" }));

    dispatch(joinClub(club.uuid))
      .unwrap()
      .then((data) => queryClient.setQueryData(["club", uuid], data));
  };

  const handleLeave = () => {
    dispatch(
      openModal({
        name: "confirmation",
        data: {
          title: "Are you sure you want to leave this club?",
          confirmText: "Yes, leave",
          onConfirm: () =>
            dispatch(leaveClub(club.uuid))
              .unwrap()
              .then((data) => queryClient.setQueryData(["club", uuid], data)),
        },
      })
    );
  };

  return (
    <>
      <header className={`${CLUB_THEMES[club.color]} w-screen flex items-center justify-center border-b px-4 md:px-0`}>
        <HeadTags title={club.name} description={club.description} />
        <div className="flex flex-col my-8 md:my-12 gap-6 m-auto max-w-[650px] justify-center items-center">
          <h1 className="flex items-center gap-2">
            {club.name}
            {club.private && <LockOutlinedIcon className="text-offBlack" fontSize="inherit" />}
          </h1>
          <h3 className="text-center">{club.description}</h3>
          {club.name !== "Pagebound Club" && club.name !== "Founder Announcements" && (
            <p className="font-bold">
              <Button
                type="text"
                onClick={() => dispatch(openModal({ name: "viewMembers", data: { club: club } }))}
                text={`${club.member_count} members`}
              />
            </p>
          )}
          {/* <div className="flex gap-6 justify-center">
            {!club.is_moderator &&
              (club.member_status === "joined" ? (
                <Button onClick={handleLeave} text="Joined" color="bg-mainGreen" size="medium" />
              ) : club.member_status === "pending" ? (
                <Button disabled text="Pending" size="medium" />
              ) : (
                <Button onClick={handleJoin} text={club.private ? "Request to Join" : "Join"} size="medium" />
              ))}
          </div> */}
        </div>
      </header>

      <div className="container justify-center mt-8 md:mt-16 items-center md:items-start md:justify-start m-auto md:px-0 w-11/12 md:w-9/12 max-w-[800px] box-border pb-[100px]">
        {/* <div className="flex gap-6 items-center justify-center my-8 md:my-16">
          <Button type="navigation" text="About Us" isActive={view === "about-us"} to={`/clubs/${uuid}/about-us`} />
          <Button type="navigation" text="Forum" isActive={view === "forum"} to={`/clubs/${uuid}/forum`} />
          <Button
            type="navigation"
            text="Book Recs"
            isActive={view === "recommendations"}
            to={`/clubs/${uuid}/recommendations`}
          />
        </div> */}

        {/* {club.is_moderator ? (
          <AboutUsModeratorView club={club} refetchClub={refetchClub} />
        ) : (
          <AboutUsMemberView club={club} />
        )} */}

        <div className="flex justify-center">
          {club.private && club.member_status !== "joined" ? (
            <div className="flex flex-col gap-3 box-border border border-offBlack shadow-main rounded-default bg-mainBlue p-5 md:p-8 w-full max-w-[800px]">
              <div className="bg-white rounded-xl p-6 text-center">
                This club is private! Request to join to see and participate in the discussion.
              </div>
            </div>
          ) : (
            <Forum resource={club} resourceType="Club" />
          )}
        </div>
      </div>
    </>
  );
};

export default withFallback(ClubShow, undefined, () => <h2>Oops! No club found.</h2>);
